export type SplashStage = 'quiet' | 'connecting' | 'loading' | 'almost' | 'slow';

export const SPLASH_QUERY_PARAM = 'splash';

export const SPLASH_FADE_TRANSITION_CLASS =
  'transition-[opacity,transform] [transition-duration:280ms] motion-reduce:transition-none';

export const SPLASH_TIMING = {
  minVisible: 500,
  quiet: 1200,
  loading: 2400,
  almost: 4200,
  slow: 6000,
  watchdog: 20000,
  curtain: 340,
} as const;

export const STAGE_LINE_KEYS: Record<SplashStage, string | null> = {
  quiet: null,
  connecting: 'splash_connecting',
  loading: 'splash_loading_your_check_in',
  almost: 'splash_almost_ready',
  slow: 'splash_taking_longer',
};

export const ANNOUNCE_KEYS: Record<SplashStage, string | null> = {
  quiet: null,
  connecting: 'splash_announce_connecting',
  loading: 'splash_announce_loading',
  almost: 'splash_announce_loading',
  slow: 'splash_announce_slow',
};

export const getAnnounceKey = (stage: SplashStage, isHandingOff = false) =>
  isHandingOff ? 'splash_announce_ready' : ANNOUNCE_KEYS[stage];
